<template>
  <div class="obt-live">
    <div class="hasData-wrap">
      <div class="time-box">
        <div class="publish-time" v-if="egObtLiveResult.length > 0">
<!--          <i class="el-icon-time"></i>-->
<!--          数据时间：{{ $moment(egObtLiveResult[0].ddatetime).format('YYYY-MM-DD hh:mm') }}-->
          <div>{{ $moment(egObtLiveResult[0].ddatetime).format('YYYY-MM-DD hh:mm') }}更新</div>
        </div>
      </div>
      <div class="cont-box">
        <el-carousel :autoplay="false" height="100%" indicator-position="outside" arrow="never">
          <el-carousel-item v-for="(item, index) in egObtLiveResult" :key="index">
            <div class="name">
              <img src="@/assets/images/obtlive@2x.png" alt="">
              {{ item.obtname }}
            </div>
            <div class="item-wrap">
              <div class="item-row">
                <div class="item">气温&ensp;{{ item.t }}℃</div>
                <div class="item"> &ensp;&ensp;相对湿度 &ensp;{{ item.rh }}%</div>
                <div class="item">&ensp;&ensp;&ensp;&ensp;平均风向 &ensp;{{ findWinds(item.wd2dd) }}</div>
              </div>
              <div class="item-row">
                <div class="item">气压&ensp;{{ item.p }}hPa</div>
                <div class="item">分钟将水量&ensp;{{ item.rm }}mm</div>
                <div class="item">&ensp;&ensp;&ensp;&ensp;平均风速&ensp;{{ item.wd2df }}m/s</div>
              </div>
              <div class="item-row">
                <div class="item">路温&ensp;{{ item.dt }}℃</div>
                <div class="item">分钟能见度&ensp;{{ item.v }}m</div>
                <div class="item">10min能见度 &ensp;{{ item.v10 }}m</div>
              </div>
            </div>

          </el-carousel-item>
        </el-carousel>

      </div>

    </div>
  </div>
</template>

<script>
import { findWind } from '@/utils/tool.js'
import { mapState } from 'vuex'
export default {
  data () {
    return {}
  },
  computed: {
    ...mapState('home', ['egObtLiveResult'])
  },
  methods: {
    findWinds (windd) {
      return findWind(windd)
    }
  }
}
</script>

<style lang="less" scoped>
.obt-live {
  display: flex;
  flex-direction: column;
  height: calc(100% - 3vw);
  width: 100%;

  .cont-box {
    display: flex;
    flex: 1;
    overflow: hidden;

    /deep/ .el-carousel {
      position: relative;
      display: flex;
      flex: 1;
      overflow: hidden;
      padding-bottom: 0.98vw;

      .el-carousel__container {
        flex: 1;

        .el-carousel__item {
          display: flex;
          flex-direction: column;
        }

      }

    }

    /deep/ .el-carousel__indicators {
      position: absolute;
      bottom: -0.5vw;
      left: 50%;
    }

    /deep/ .el-carousel__button {
      width: 0.31vw;
      height: 0.31vw;
      border-radius: 0.31vw;
      background: #85C1FF;

    }

    .name {
      display: flex;
      align-items: center;
      margin-bottom: 0.42vw;
      font-size: 0.73vw;
      font-weight: 600;
      color: #FFFFFF;
      line-height: 1.04vw;

      img {
        margin-right: 0.52vw;
        width: 0.73vw;
      }
    }

    .item-wrap {
      display: flex;
      flex-wrap: wrap;
      flex: 1;

      .item-row {
        display: flex;
        width: 100%;
        height: calc(100% / 3);
        background: rgba(24, 63, 95, 0.8);

        .item {
          display: flex;
          align-items: center;
          width: calc(100% / 3);
          height: 100%;
          // flex: 1;
          box-sizing: border-box;
          overflow: hidden;
          // padding-left: 1.2vw;
          // border-radius: 0.42vw 0.42vw 0vw 0vw;
          font-size: 0.73vw;
          color: #FFFFFF;
          line-height: 1.04vw;
          font-weight: 400;
        }

        .item:nth-child(1) {
          padding-left: 2.2vw;
        }

        .item:nth-child(2) {
          padding-left: 1.2vw;
          border-right: 1px solid rgba(255, 255, 255, 0.1);
          border-left: 1px solid rgba(255, 255, 255, 0.1);
        }

        .item:nth-child(3) {
          // padding-left: 0.5vw;
        }
      }

      .item-row:nth-child(1) {
        border-radius: 0.42vw 0.42vw 0 0;
      }

      .item-row:nth-child(3) {
        border-radius: 8px 8px 0 0;
      }

      .item-row:nth-child(2) {
        background: rgba(36, 80, 115, 0.8);
      }
    }

  }

  .hasData-wrap {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
  }

  .tab-box {
    display: flex;
    position: absolute;
    top: -2vw;
    left: 7.86vw;
    z-index: 10;
    transform: translateY(-50%);
    // padding: 10px 0 0 20px;

    .tab-item {
      margin-right: 0.78vw;
      color: #FFF;
      font-size: 0.73vw;
      font-weight: 600;
      cursor: pointer;

    }

    .tab-item.active {
      color: #ffb700;
    }

  }

  .cont-box {
    padding: 0.26vw 0.52vw;
    flex: 1;
    line-height: 1.82vw;
    color: #FFF;
    font-size: 0.73vw;
    font-weight: 600;
  }

  .publish-time {
    display: flex;
    align-items: center;
    position: absolute;
    right: 2.08vw;
    top: -1.6vw;
    color: #FFF;
    font-size: 0.63vw;

    .el-icon-time {
      margin-right: 0.26vw;
    }
  }

  .point-box {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 60%;
    transform: translateY(-50%);
    right: 0.6vw;

    .point-item {
      width: 0.32vw;
      height: 0.32vw;
      margin-bottom: .6vw;
      border: 1px solid #EEE;
      background: #FFF;
      border-radius: 100%;
    }

    .point-item:hover {
      background: #ffb700;
      cursor: pointer;
    }
  }
}
</style>
